import { defineComponent as _defineComponent } from 'vue'
import { URMRole, URMRoleKey, URMRoles } from "@/models/dto/userRoleManagement";
import { computed, ref, watch } from "vue";
import { ContactGroup, Contact } from "@/models/dto/ContactGroup";
import DialogLayout from "@/components/common/DialogLayout.vue";
import CreateEditContactContent from "./CreateEditContactContent.vue";
import { ContactType } from "./utils/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEditContact',
  props: {
    value: { type: Boolean, default: false },
    title: null,
    subtitle: null,
    submitButtonText: null,
    headerActionRightText: null,
    headerActionLeftText: null,
    userRoles: null,
    contactGroups: null,
    defaultDisabledUserRoles: null,
    userTypeDisabled: { type: Boolean },
    userTypeMessage: null,
    defaultUserType: null,
    persistent: { type: Boolean },
    contact: null,
    isEditMode: { type: Boolean },
    preventDefaultHeaderClose: { type: Boolean, default: false },
    contactListIsEditable: { type: Boolean, default: false },
    contactType: null,
    entityId: null
  },
  emits: [
  "input",
  "close",
  "click:header-action-right",
  "click:header-action-left",
  "click:edit-contact",
  "click:remove-contact",
  "remove:contact",
  "update:contact",
  "add:contact",
],
  setup(__props: any, { emit }) {

const props = __props as { value: boolean, title: string, subtitle?: string, submitButtonText: string, headerActionRightText?: string, headerActionLeftText?: string, userRoles?: URMRole[], contactGroups: ContactGroup[], defaultDisabledUserRoles?: URMRole[], userTypeDisabled?: boolean, userTypeMessage?: string, defaultUserType?: URMRoleKey, persistent?: boolean, contact?: Contact, isEditMode: boolean, preventDefaultHeaderClose: boolean, contactListIsEditable: boolean, contactType: ContactType, entityId: number };


const defaultUserRoles = [URMRoles.TripAuthorizedUser, URMRoles.TripViewOnly];

const authorizedUserDisabledRoles = [URMRoles.TripAuthorizedUser];



const isDialogOpen = ref<boolean>(false);
const defaultDisabledUserRoles = computed(() => {
  return props.defaultDisabledUserRoles || authorizedUserDisabledRoles;
});
const userRoles = ref<URMRole[]>(props.userRoles || defaultUserRoles);
const transitionName = ref("slide-right");
const shouldAnimate = ref(false);

let prevIsEditMode = props.isEditMode;
let prevContactId = props.contact?.externalId;

watch(
  () => props.value,
  (newValue) => {
    isDialogOpen.value = newValue;
    if (!newValue) {
      shouldAnimate.value = false;
    }
  }
);

// this controls the sliding animation between the edit and create contact modes
// we want to animate when the dialog is open and the edit mode changes
// the content will slide left when switching to edit mode and right when switching to create mode
watch(
  [() => props.isEditMode, () => props.contact?.externalId],
  ([newIsEditMode, newContactId], [oldIsEditMode, oldContactId]) => {
    if (isDialogOpen.value) {
      if (oldIsEditMode !== undefined && oldIsEditMode !== newIsEditMode) {
        shouldAnimate.value = true;
        transitionName.value = newIsEditMode ? "slide-left" : "slide-right";
      }
    }
    prevIsEditMode = newIsEditMode;
    prevContactId = newContactId;
  },
  { immediate: true }
);

watch(
  () => isDialogOpen.value,
  (newValue) => {
    if (newValue !== props.value) {
      emit("input", newValue);
    }
  }
);

const handleClose = () => {
  isDialogOpen.value = false;
  shouldAnimate.value = false;
  transitionName.value = "slide-right";
  emit("input", false);
};

const handleDialogInput = (val) => {
  isDialogOpen.value = val;
  if (!val) {
    handleClose();
  }
};

const handleEditContactClick = (payload: Contact) => {
  emit("click:edit-contact", payload);
};

const handleRemoveContactClick = (payload: Contact) => {
  emit("click:remove-contact", payload);
};


return { __sfc: true,emit, defaultUserRoles, authorizedUserDisabledRoles, props, isDialogOpen, defaultDisabledUserRoles, userRoles, transitionName, shouldAnimate, prevIsEditMode, prevContactId, handleClose, handleDialogInput, handleEditContactClick, handleRemoveContactClick, DialogLayout, CreateEditContactContent }
}

})